import { useCallback } from 'react';

import { useProductForRestaurantQuery } from '@order/graphql';
import { useNavigateToProductDetails } from '@order/hooks';
import { useTelemetry } from '@order/Telemetry';

export const useNavigateToBaseProductDetail = ({
  baseProductSlug,
  restaurantId,
  restaurantSlug = '',
  deliveryAddressId,
  isContinueButtonEnabled,
}: useNavigateToBaseProductDetailParams) => {
  const navigateToPDP = useNavigateToProductDetails({
    restaurantSlug,
    deliveryAddressId,
  });
  const { track } = useTelemetry();

  const [productForRestaurantResponse] = useProductForRestaurantQuery({
    requestPolicy: 'cache-and-network',
    variables: {
      baseProductSlug,
      restaurantId,
    },
    pause: !baseProductSlug || !restaurantId,
  });

  const productForRestaurantSlug =
    productForRestaurantResponse?.data?.productForRestaurant?.slug;

  return useCallback(() => {
    if (!productForRestaurantSlug) return;

    if (isContinueButtonEnabled) {
      track('deep-linking.continue_pdp_flow');
      navigateToPDP({
        slug: productForRestaurantSlug,
      });
    } else {
      track('deep-linking.order_now_flow');
      //add addLineItemToCart hook for Order Now functionality
    }
  }, [navigateToPDP, productForRestaurantSlug, isContinueButtonEnabled, track]);
};

type useNavigateToBaseProductDetailParams = {
  readonly baseProductSlug: string;
  readonly restaurantId: string;
  readonly restaurantSlug?: string;
  readonly deliveryAddressId?: string;
  readonly isContinueButtonEnabled?: boolean;
};
